<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente icono-titulo="fas fa-plus" texto-titulo="Nuevo Cargo" />
      <div class="tab-content">
        <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarCargo()">
                    <float-label label="Código:" clase>
                      <input
                        v-model="cargo.codigo"
                        id="codigo"
                        placeholder="Ingresar un código..."
                        type="text"
                        class="form-control"
                        :class="(enviado && !$v.cargo.codigo.required) ? 'is-invalid' : ''"
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.cargo.codigo.required"
                        >Debe ingresar un código</div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase>
                      <input
                        id="descripcion"
                        v-model="cargo.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.cargo.descripcion.required"
                        >Debe ingresar una descripción</div>
                      </template>
                    </float-label>
                    <float-label label="Código nomenclador:" clase>
                      <input
                        v-model="cargo.codigo_nomenclador"
                        id="codigo_nomenclador"
                        placeholder="Ingresar código de nomenclador..."
                        type="text"
                        class="form-control"
                        :class="(enviado && !$v.cargo.codigo_nomenclador.required) ? 'is-invalid' : ''"
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.cargo.codigo_nomenclador.required"
                        >Debe ingresar un código de nomenclador</div>
                      </template>
                    </float-label>
                    <float-label label="Cantidad de horas:" clase>
                      <input
                        v-model="cargo.cantidad_horas"
                        id="cantidad_horas"
                        placeholder="Ingresar cantidad de horas..."
                        type="text"
                        class="form-control"
                        :class="(enviado && !$v.cargo.cantidad_horas.required) ? 'is-invalid' : ''"
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.cargo.cantidad_horas.required"
                        >Debe ingresar cantidad de horas</div>
                      </template>
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">Guardar</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import Cargo from "@/models/cargo";
import axios from "axios";
export default {
  name: "NuevoCargo",
  components: {
    TituloComponente,
    FloatLabel,
  },
  data() {
    return {
      cargo: new Cargo(null, "", "", null, null),
      enviado: false,
      loading: false,
    };
  },
  validations: {
    cargo: {
      codigo: { required },
      descripcion: { required },
      codigo_nomenclador: { required },
      cantidad_horas: { required },
    },
  },
  methods: {
    guardarCargo() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .post("/cargos", this.cargo)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarCargos" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>